import { MyleHelper } from "@/Common/Helpers/MyleHelper";

class ContactRenderHelper {
    /**
     * Render empty section view
     * @param {string} key
     * @returns {JSX.Element}
     */
    public static renderEmptyView(key: string): JSX.Element {
        return (
            <tbody key={key}>
                <tr>
                    <td className="c1"><span>--</span></td>
                    <td className="c2" />
                </tr>
            </tbody>
        );
    }

    /**
     * Render row with provided React Element
     * @param {string} label
     * @param {React.ReactNode} element
     * @param {string} dataCy
     * @returns {JSX.Element}
     */
    public static renderRow(label: string, element: React.ReactNode, dataCy: string): JSX.Element {
        let toRender = element;

        if (typeof element === "string" || typeof element === "undefined")
            toRender = MyleHelper.ReplaceEmptyString(element);

        return (
            <tr>
                <td className="c1">
                    <span className="float-right">{label}</span>
                </td>
                <td className="c2 text-break-word">
                    <strong data-cy={dataCy}>{toRender}</strong>
                </td>
            </tr>
        );
    }
}

export { ContactRenderHelper };
